import { DigitalMeter  } from "../../classes";

const DigitalMeterModule = {
  namespaced: true,
  state: {
  },
  actions: {
    getLatestMeterData: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.getLatestMeterData(
          payload.partner,
          payload.type,
          payload.cust_id,
          payload.meterAddress,
          payload.datetime);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getLatestMeterStatus: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.getLatestMeterStatus(
          payload.partner,
          payload.type,
          payload.cust_id,
          payload.meterAddress);
        return data;
      } catch (err) {
        throw err;
      }
    },
    turnOnDigitalMeter: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.turnOnDigitalMeter(
          payload.meterId,
          payload.note
        );
        return data;
      } catch (err) {
        throw err;
      }
    },
    turnOffDigitalMeter: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.turnOffDigitalMeter(
          payload.meterId,
          payload.note,
        );
        return data;
      } catch (err) {
        throw err;
      }
    },
    addBalanceDigitalMeter: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.addBalanceDigitalMeter(
          payload.meterId,
          payload.note,
        );
        return data;
      } catch (err) {
        throw err;
      }
    },
    resetBalanceDigitalMeter: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeter.resetBalanceDigitalMeter(
          payload.meterId,
          payload.amount,
          payload.note,
        );
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {

  },
  mutations: {

  }
};
export default DigitalMeterModule;
